module.exports = __webpack_public_path__ + "img/img03.39e44c3f.jpeg";